import request from '@/utils/request'
import { cache } from '@/utils/cacheManager'
import URL from '@/api/urlTranslator'

export function repositoryServlet(params) {
  let url = cache.config.get('H5DwURL')
  if (url.endsWith('/')) {
    url = url.substr(0, url.length - 1)
  }
  url += URL.dw.repositoryServlet
  if (!params.hasOwnProperty('returnJson')) {
    params.returnJson = true
  }
  return request({
    url,
    method: 'post',
    params
  })
}

export function runtimeServlet(params) {
  let url = cache.config.get('H5DwURL')
  if (url.endsWith('/')) {
    url = url.substr(0, url.length - 1)
  }
  url += URL.dw.runtimeServlet
  if (!params.hasOwnProperty('returnJson')) {
    params.returnJson = true
  }
  const data = new FormData()
  for (const key in params) {
    data.append(key, params[key])
  }
  return request({
    url,
    method: 'post',
    data
  })
}

export function getRuntimeServletUrl() {
  let url = cache.config.get('H5DwURL')
  if (url.endsWith('/')) {
    url = url.substr(0, url.length - 1)
  }
  return url + URL.dw.runtimeServlet
}

// 查询个人配置列表
export function queryPersonUiConfig(params) {
  let url = cache.config.get('H5DwURL')
  if (url.endsWith('/')) {
    url = url.substr(0, url.length - 1)
  }
  url += URL.dw.queryPersonUiConfig
  return request({
    url,
    method: 'get',
    params
  })
}

// 保存个人配置
export function savePersonUiConfig(body) {
  let url = cache.config.get('H5DwURL')
  if (url.endsWith('/')) {
    url = url.substr(0, url.length - 1)
  }
  url += URL.dw.savePersonUiConfig
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url,
    method: 'post',
    data
  })
}

// 获取最晚更新时间
export function queryLastUpdateTime(params) {
  let url = cache.config.get('H5DwURL')
  if (url.endsWith('/')) {
    url = url.substr(0, url.length - 1)
  }
  url += URL.dw.queryLastUpdateTime
  return request({
    url,
    method: 'post',
    params
  })
}
